import { SET_NAVIGATION_CONFIRM, REMOVE_NAVIGATION_CONFIRM } from './types';

export const _beforeUnload = e => {
  e.returnValue = '';
};

export const setNavConfirm = () => dispatch => {
  window.addEventListener('beforeunload', _beforeUnload);
  dispatch({ type: SET_NAVIGATION_CONFIRM });
};

export const removeNavConfirm = () => dispatch => {
  window.removeEventListener('beforeunload', _beforeUnload);
  dispatch({ type: REMOVE_NAVIGATION_CONFIRM });
};
